import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import TeamMemberCard from "../../components/TeamMemberCard/TeamMemberCard";
import ExpandedCard from "../../components/ExpandedCard/ExpandedCard";
import teamData from "./teamData";

const missionStatement = "At All Animal App, we have centralized accessible resources to improve animal welfare worldwide while fostering a compassionate, connected community. With innovative and reliable tools, we empower every individual to make a meaningful impact.";

const About = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const handleCardClick = (member) => {
    setSelectedMember(member);
  };

  const closeExpandedCard = () => {
    setSelectedMember(null);
  };

  useEffect(() => {
    if (selectedMember) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedMember]);

  const carmen = teamData[0];
  const devyn = teamData[1];
  const milan = teamData[2];
  const teaghan = teamData[3];

  return (
    <section className="relative py-24 px-4 scroll-mt-24 bg-[#f7f8f7]">
      <div className="relative z-10 max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block text-[#6B8F8A] text-sm font-semibold tracking-widest uppercase mb-3">
            Who We Are
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#3a3a3a] mb-6">
            Our Mission
          </h2>
        </div>

        <div className="relative w-full aspect-video md:aspect-[2.5/1] rounded-2xl overflow-hidden mb-8 shadow-lg">
          <img 
            src="/images/mission-animals.jpg" 
            alt="Animals together representing our mission of compassion"
            className="w-full h-full object-cover"
            style={{ objectPosition: 'center 90%' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#4a6e69]/30 to-transparent" />
        </div>

        <p className="text-lg md:text-xl text-[#6b7280] leading-relaxed max-w-3xl mx-auto text-center mb-20">
          {missionStatement}
        </p>

        <span className="block text-center text-[#6B8F8A] text-sm font-semibold tracking-widest uppercase mb-3">
          Our People
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-[#3a3a3a] text-center mb-12">
          Meet Our Team
        </h2>

        <div className="flex justify-center mb-8">
          <div className="w-full max-w-sm">
            <TeamMemberCard
              name={carmen.name}
              role={carmen.role}
              image={carmen.image}
              description={carmen.description}
              socialLinks={carmen.socialLinks}
              onClick={() => handleCardClick(carmen)}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="h-full">
            <TeamMemberCard
              name={devyn.name}
              role={devyn.role}
              image={devyn.image}
              description={devyn.description}
              socialLinks={devyn.socialLinks}
              onClick={() => handleCardClick(devyn)}
            />
          </div>
          <div className="h-full">
            <TeamMemberCard
              name={milan.name}
              role={milan.role}
              image={milan.image}
              description={milan.description}
              socialLinks={milan.socialLinks}
              onClick={() => handleCardClick(milan)}
            />
          </div>
          <div className="sm:col-span-2 lg:col-span-1 sm:flex sm:justify-center lg:block h-full">
            <div className="w-full sm:max-w-[calc(50%-12px)] lg:max-w-none h-full">
              <TeamMemberCard
                name={teaghan.name}
                role={teaghan.role}
                image={teaghan.image}
                description={teaghan.description}
                socialLinks={teaghan.socialLinks}
                onClick={() => handleCardClick(teaghan)}
              />
            </div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {selectedMember && (
          <ExpandedCard member={selectedMember} onClose={closeExpandedCard} />
        )}
      </AnimatePresence>
    </section>
  );
};

export default About;
